import styled from "styled-components";

const PrintWrapper = styled.div`
  /* display: flex;
  flex-direction: column;
  max-width: 1000px; */
  .verticalSeperator {
    height: 30px;
  }
  /* .ant-table.ant-table-bordered > .ant-table-container {
    border-color: transparent !important;
  } */
  .print_header {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .spacerContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .rowContainer {
    display: flex;
  }
  .horizontal_spacer {
    width: ${(props) => (props["print"] === true ? "10px" : "40px")};
  }
  .vertical_spacer {
    height: 10px;
    &.high {
      height: 30px;
    }
  }
  .horizontal_item_container {
    display: flex;
  }
  .item_container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .item_container_auto {
    display: flex;
    flex-direction: column;
  }
  .section {
    width: 100%;
    border: 1px solid;
    padding: 10px;
  }
`;

export default PrintWrapper;
